/*
 * Dashboard Call History
 *
 * - Holds the most recent inbound, outbound and missed calls
 * - Holds a counter for number of missed calls since last outbound/answered call
 */

import { ref } from 'vue'
import { defineStore } from 'pinia'
import logger from '@/utilities/Logger'
import type { GlyphIconName } from './GlyphIcons.types'
import axios from 'axios'

export const useGlyphIconsStore = defineStore('glyphIcons', () => {
	logger.debug('GlyphIcons: Initializing store')

	const cache = ref<Record<string, string>>({})
	const loading = ref<GlyphIconName[]>([])

	async function getIcon(name: GlyphIconName) {
		if (cache.value[name]) {
			return cache.value[name]
		}

		if (loading.value.includes(name)) {
			while (loading.value.includes(name)) {
				await new Promise(resolve => setTimeout(resolve, 100))
			}
			return cache.value[name]
		}

		loading.value.push(name)

		try {
			const res = await axios.get(`/glyphicons/glyphicons-basic-${name as string}.svg`)

			cache.value[name] = res.data as string
			loading.value.splice(loading.value.indexOf(name), 1)
			return res.data as string
		}
		catch (err) {
			logger.error(`GlyphIcons: Failed to load icon ${name}: ${(err as Error).message}`)
			return undefined
		}
	}

	return { getIcon }
})
